import moment from 'moment';

export namespace DateTimeHelper {
	export const FIVE_MINS_IN_MILLISECONDS = 300000;
	export const ONE_MINS_IN_MILLISECONDS = 60000;

	export const formatValue = (value: number) => {
		if (value >= 10) {
			return value;
		} else {
			return '0' + value;
		}
	};

	export const getTimeFromNow = (toTime: string) => {
		const evtStartTime = Date.parse(toTime);
		const now = Date.now();
		return evtStartTime - now;
	};

	export const parseTimeToNumber = (time: string) => {
		const timeToStart = DateTimeHelper.getTimeFromNow(time);
		const days = Math.floor(timeToStart / 86400000);
		const hours = Math.floor((timeToStart - days * 86400000) / 3600000);
		const minutes = Math.floor((timeToStart - days * 86400000 - hours * 3600000) / 60000);
		const seconds = Math.floor((timeToStart - days * 86400000 - hours * 3600000 - minutes * 60000) / 1000);

		let toReturn = '';

		if (days > 0) {
			toReturn += formatValue(days) + ':';
		}

		if (hours > 0 || toReturn) {
			toReturn += formatValue(hours) + ':';
		}

		toReturn += formatValue(minutes) + ':';
		toReturn += formatValue(seconds);

		return toReturn;
	};

	export const formatDate = (timestamp: string, translator: any, currentLang?: string) => {
		const eventStartDate = new Date(timestamp);

		const day = eventStartDate.getDate();
		const month = 'MONTH_' + eventStartDate.getMonth();
		const year = eventStartDate.getFullYear();

		const hour = eventStartDate.getHours();
		const minute = eventStartDate.getMinutes();

		const minuteToShow = minute < 10 ? '0' + minute : minute;
		const hourToShow = hour < 10 ? '0' + hour : hour;

		return day + ' ' + translator(month) + ' ' + year + (currentLang === 'sv' ? ' kl. ' : ', ') + hourToShow + ':' + minuteToShow;
	};

	export const formatHumanize = (timeToFormat: string, translator: any) => {
		let time = DateTimeHelper.getTimeFromNow(timeToFormat);
		if (isNaN(+time) || !isFinite(+time) || 0.5 > Math.abs(time)) {
			return '';
		}

		const sign = time < 0 ? '-' : '';
		time = Math.abs(time);

		const days = Math.floor(time / 86400000);
		const hours = Math.floor((time - days * 86400000) / 3600000);
		const minutes = Math.floor((time - days * 86400000 - hours * 3600000) / 60000);
		const seconds = Math.floor((time - days * 86400000 - hours * 3600000 - minutes * 60000) / 1000);

		let formattedTime = sign;

		if (days > 0) {
			formattedTime += days + ' ' + translateTimeLabelWithPluralize('LABEL_DAY', translator, days) + ' ';
		}

		if (hours > 0) {
			formattedTime += hours + ' ' + translateTimeLabelWithPluralize('LABEL_HOUR', translator, hours) + ' ';
		}

		if (minutes > 0) {
			formattedTime += minutes + ' ' + translateTimeLabelWithPluralize('LABEL_MINUTE', translator, minutes) + ' ';
		}

		if (seconds > 0) {
			formattedTime += seconds + ' ' + translateTimeLabelWithPluralize('LABEL_SECOND', translator, seconds) + ' ';
		}

		if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
			formattedTime += seconds + ' ' + translateTimeLabelWithPluralize('LABEL_SECOND', translator, seconds) + ' ';
		}

		return formattedTime;
	};

	export const formatHumanizeDuration = (timeToFormat: string, translator: any) => {
		const times = timeToFormat.split(':');

		let hours = 0;
		let minutes = 0;
		let seconds = 0;
		if (times.length === 1) {
			seconds = parseInt(times[0]);
		}
		if (times.length === 2) {
			minutes = parseInt(times[0]);
			seconds = parseInt(times[1]);
		}
		if (times.length === 3) {
			hours = parseInt(times[0]);
			minutes = parseInt(times[1]);
			seconds = parseInt(times[2]);
		}

		let formattedTime = '';

		if (hours > 0) {
			formattedTime += hours + ' ' + translateTimeLabelWithPluralize('LABEL_HOUR', translator, hours) + ' ';
		}

		if (minutes > 0) {
			formattedTime += minutes + ' ' + translateTimeLabelWithPluralize('LABEL_MINUTE', translator, minutes) + ' ';
		}

		if (seconds > 0) {
			formattedTime += seconds + ' ' + translateTimeLabelWithPluralize('LABEL_SECOND', translator, seconds) + ' ';
		}

		return formattedTime;
	};

	export const translateTimeLabelWithPluralize = (translationKey: string, translator: any, count: number) => {
		if (count > 1) {
			return translator(`${translationKey}S`);
		} else {
			return translator(translationKey);
		}
	};

	export const checkTimeGreaterThan5Mins = (evtStartTime: number) => {
		const diff = Math.abs(moment(Date.now()).diff(moment(evtStartTime)));

		return diff > FIVE_MINS_IN_MILLISECONDS;
	};

	export const checkTimeDivideByNumber = (evtStartTime: number, numberToCompare?: number) => {
		const delta = numberToCompare ? numberToCompare : 5;
		const diffInMins = moment.duration(moment(Date.now()).diff(moment(evtStartTime))).minutes();
		const diffInSeconds = moment.duration(moment(Date.now()).diff(moment(evtStartTime))).seconds();

		return Math.abs(diffInMins) % delta === 0 && Math.abs(diffInSeconds) === 0;
	};
}
